import AssignmentDetailSheet from "./AssignmentDetailSheet"

type Props = {
  instructions: string
  richTextClassName: string
  open: boolean
  onClose: () => void
}

const Instructions = ({
  instructions,
  richTextClassName,
  open,
  onClose,
}: Props) => (
  <AssignmentDetailSheet
    title="Task Instructions"
    open={open}
    onClose={onClose}
  >
    <div
      className={richTextClassName}
      dangerouslySetInnerHTML={{
        __html: instructions,
      }}
    />
  </AssignmentDetailSheet>
)

export default Instructions
